import { authSplitApi } from 'redux/helpers/slice.helpers';
import { EProfileUrls } from 'data/urls/profile.url';
import {
  TAdminProfileDB,
  TAdminProfileUI,
  TUpdateFullNameUI,
  TUpdateProfilePictureUI,
} from 'data/types/Profile.types';

export const profileApi = authSplitApi('profileApi', ['Profile']).injectEndpoints({
  endpoints: build => ({
    getAdminProfile: build.query<TAdminProfileUI, void>({
      query: () => ({
        url: EProfileUrls.PROFILE,
        method: 'GET',
      }),
      providesTags: ['Profile'],
      transformResponse: (data: TAdminProfileDB): TAdminProfileUI => ({
        id: data.id,
        name: data.name,
        email: data.email,
        profilePicture: data.profilePicture,
        photoPreSignedUrl: data.photoPreSignedUrl,
      }),
    }),
    updateProfilePicture: build.mutation<void, TUpdateProfilePictureUI>({
      query: body => ({
        url: `${EProfileUrls.PROFILE}/${EProfileUrls.PROFILE_PICTURE}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Profile'],
    }),
    updateFullName: build.mutation<void, TUpdateFullNameUI>({
      query: body => ({
        url: `${EProfileUrls.PROFILE}/${EProfileUrls.NAME}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Profile'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAdminProfileQuery,
  useUpdateProfilePictureMutation,
  useUpdateFullNameMutation,
} = profileApi;
